import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const creditsApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCreditPricingTiers: builder.query({
      query: ({ adminId }) => ({
        url: `${API_BASE_URL}/credits_prices/${adminId}`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result && Array.isArray(result)) {
          return [
            ...result.map(({ id }) => ({
              type: "CreditTier",
              id,
            })),
            { type: "CreditTierList", id: "LIST" },
          ];
        }
        return [{ type: "CreditTierList", id: "LIST" }];
      },
    }),
    updateCreditPricingTiers: builder.mutation({
      query: ({ adminId, tiers }) => ({
        url: `${API_BASE_URL}/credits_prices/${adminId}`,
        method: "PUT",
        body: tiers,
      }),
      invalidatesTags: (result, error, pricingTiers) => [
        { type: "CreditTierList", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetCreditPricingTiersQuery,
  useUpdateCreditPricingTiersMutation,
} = creditsApi;
